/*
 * @Author: Cozy
 * @Date: 2024-07-29 18:50:12
 * @LastEditors: Cozy
 * @LastEditTime: 2024-08-11 00:08:31
 * @FilePath: /SChatUI/src/InsightChat.js
 * @Description: 
 * 
 * Copyright (c) 2024 by Cozy, All Rights Reserved. 
 */
// InsightChat.js  
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Chat, { Bubble, useMessages, RichText, Divider, Popup, RadioGroup, Button, Text, Input, toast } from "@chatui/core";
import { v4 as uuidv4 } from 'uuid';
import io from 'socket.io-client';
import "@chatui/core/dist/index.css";
import DOMPurify from 'dompurify'; 

export default function InsightChat() {
    const { service, sessionId } = useParams();
    const [params, setParams] = useState({
        user_id: '',
        rep_id: '',
        smi_id: '',
        task_id: '',
        cust_name: ''
    });
    const { messages, appendMsg, updateMsg, deleteMsg, setTyping } = useMessages([]);
    // const { user, clearAuth, accessToken, refreshAttempts, accessibleServices } = useContext(AuthContext);
    const [open, setOpen] = useState(false);
    const [suggestionMsgId, setSuggestionMsgId] = useState(null);
    const [currentSuggestion, setCurrentSuggestion] = useState(null);
    const [socket, setSocket] = useState(null);
    const [isTranslateEnabled, setisTranslateEnabled] = useState(true);
    const [isLikeEnabled, setisLikeEnabled] = useState(true);
    const [isQuickRepliesVisible, setisQuickRepliesVisible] = useState(true);
    const [value3, setValue3] = useState('');
    const [supportedLanguages, setSupportedLanguages] = useState([
        { label: '中文', value: 'Chinese' },
        { label: 'Español', value: 'Spanish' },
        { label: 'English', value: 'English' },
    ]);

    const chatInstanceRef = useRef(null);
    // 注意此处是多语种适配翻译，而不是翻译语言，支持的翻译语言随配置下发
    const translations = {
        en: 'Translate',
        zh: '翻译',
        es: 'Traducir',
        ja: '翻訳',
        ko: '플랫폼',
        fr: 'Traduire'
    };
    const userLanguage = navigator.language.slice(0, 2); // 获取用户语言代码
    const translateText = translations[userLanguage] || translations.en; // 根据用户语言选择翻译文本 
    function handleUseTranslatedText() {

        if (chatInstanceRef.current) {
            console.log("chatInstanceRef.current:", chatInstanceRef);
            chatInstanceRef.current.setText(translatedInput);
            // chatInstanceRef.current.setInputValue(translatedInput);
        }
        handleClose();

    }
    const defaultQuickReplies = [
        {
            name: `🌐 ${translateText}`,
            isHighlight: true,
        },
        {
            name: 'mock_test_msg',
            isNew: true
        }
    ];
    const messagesRef = useRef(messages);

    useEffect(() => {
        messagesRef.current = messages;
    }, [messages]);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const user_id = queryParams.get('user_id');
        const rep_id = queryParams.get('rep_id');
        const smi_id = queryParams.get('smi_id');
        const task_id = queryParams.get('task_id');
        const cust_name = queryParams.get('cust_name');

        setParams({
            user_id: user_id,
            rep_id: rep_id,
            smi_id: smi_id,
            task_id: task_id,
            cust_name: cust_name
        });


    }, []);

    useEffect(() => {
        if (!params.user_id || !params.rep_id || !params.smi_id || !params.task_id) {
            console.warn("Missing or invalid params");
            return;
        }
        socket.emit('join', {
            user_id: params.user_id,
            rep_id: params.rep_id,
            smi_id: params.smi_id,
            task_id: params.task_id
        });
    }, [params]);

    useEffect(() => {
        const socket = io(process.env.REACT_APP_INSIGHTHUB_BASE_URL, {
            transports: ['websocket'],
            withCredentials: true,
            auth: {
                token: 'accessToken'
            },
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            randomizationFactor: 0.5
        });

        setSocket(socket);

        socket.on('invalid_token', () => {
            console.error('invalid_token');
            // clearAuth();
        });

        const appendMessage = (msg) => {
            appendMsg({
                _id: msg.message_id,
                type: "text",
                content: {
                    text: msg.content,
                    tag: msg.tag,
                    target_language: msg.target_language,
                    translated_text: msg.translated_text,
                    direction: msg.direction,
                    messageBuilder: msg.messageBuilder
                },
                //  //消息方向 1代理发给客户 2客户发给代理
                position: msg.direction === "2" ? "left" : "right",
                createdAt: new Date(msg.timestamp).toLocaleString()
            });
        };
        socket.on('load_history', (history) => {
            history.forEach((msg) => {
                appendMessage(msg);
            });
        });


        socket.on('receive_new_message', (data) => {
            appendMessage(data);
        });


        socket.on('update_translated_message', (data) => {
            const originalMessages = [...messagesRef.current];
            console.debug("update_translated_message:", data);
            if (data && data.status === "success") {
                if (data.message_id === "MsgID_input_text") {
                    setTranslatedInput(data.translated_text);
                    return;
                }
                const messageIndex = originalMessages.findIndex((msg) => msg._id === data.message_id);
                if (messageIndex === -1) return;
                updateMsg(data.message_id, {
                    content: {
                        ...originalMessages[messageIndex].content,
                        translated_text: data.translated_text,
                        target_language: data.target_language
                    },
                    position: originalMessages[messageIndex].content.direction === "2" ? "left" : "right"
                })
            } else if (data && data.status === "error") {
                console.error("update_translated_message error:", data);

            }
            // 释放掉originalMessages的内存
            originalMessages.length = 0;
            originalMessages.splice(0, originalMessages.length);
        });
        socket.on('page_config', (data) => {
            console.debug("page_config:", data);
            setisTranslateEnabled(data.isTranslateEnabled);

            if (data.isTranslateEnabled && data.supportedLanguages && (data.supportedLanguages.length > 0)) {
                setSupportedLanguages(data.supportedLanguages);
            }

        });


        socket.on('connect_error', (err) => {
            console.debug('连接错误:', err.message);
        });

        socket.on('connect', () => {
            console.info('连接成功');
            console.debug('Socket:', socket);
        });

        socket.on("disconnect", (reason, details) => {
            console.info("断开连接");
            // the reason of the disconnection, for example "transport error"
            console.log(reason);

            // the low-level reason of the disconnection, for example "xhr post error"
            console.log(details.message);

            // some additional description, for example the status code of the HTTP response
            console.log(details.description);

            // some additional context, for example the XMLHttpRequest object
            console.log(details.context);
        });
        return () => {
            socket.disconnect();
            socket.off('receive_new_message');
            socket.off('update_message');
            socket.off('update_translated_message');
            socket.off('page_config');
            socket.off('connect_error');
            socket.off('connect');
            socket.off('disconnect');
        };
    }, []);


    const updateMessageTag = (id, tag) => {
        const messageIndex = messages.findIndex((msg) => msg._id === id);
        if (messageIndex === -1) return;

        const originalMessage = messages[messageIndex];
        const updatedMessage = {
            ...originalMessage,
            content: { ...originalMessage.content, tag },
        };

        updateMsg(id, updatedMessage);

        socket.emit('update_tag', {
            ...updatedMessage.content,
            content: updatedMessage.content.text,
            ...params,
            tag,
            message_id: id
        });
    };
    const translateTo = (message_id, content_text, target_language) => {
        socket.emit('translate', {
            ...params,
            service: service,
            message_id: message_id,
            content: content_text,
            target_language: target_language
        });
    }

    function renderMessageContent(msg) {
        const { content, _id } = msg;
        const [islike, setislikeValue] = useState(content.tag);
        const [target_language, setTargetLanguageValue] = useState(content.target_language);
        const options = [
            { label: '👍', value: 'like' },
            { label: '👎', value: 'dislike' }
        ];
        // Accessing the last message in the array
        const lastMessage = messages[messages.length - 1];
        function handleChangeisLike(val) {
            setislikeValue(val);
            updateMessageTag(_id, val)
        }

        function handleChangeLanguage(val) {
            setTargetLanguageValue(val);
            translateTo(_id, content.text, val, content);
        }

        function handleUseSuggestion() {
            if (chatInstanceRef.current) { 
                chatInstanceRef.current.setText(content.text);
                // chatInstanceRef.current.setInputValue(translatedInput);
                setSuggestionMsgId(_id);
                setCurrentSuggestion(content.text)
            } else {
                console.error("chatInstanceRef.current is null");
            }
        }
        function handleRegenerateSuggestion() {
            console.log("handleRegenerateSuggestion");
        }

        return (

            <div className={["3", "5", "7"].includes(content.messageBuilder) ? (content.messageBuilder == "7" ? "template-msg" : "ai-msg") : null}>
                {/* messageBuilder; //消息构建者 1 客户  2 客服代表 3 AI建议候选 4 人工修正AI 5 AI原文经过人工确认发送 6 模版消息（已经发送） 7模板消息建议候选 */}
                <Bubble >
                    <RichText content={content.text} />
                    {isTranslateEnabled && content.translated_text ? (
                        <div>
                            <Divider />
                            <RichText content={content.translated_text} />
                        </div>
                    ) : null}
                </Bubble>

                <div className="message-footer">
                    {/* 点赞功能使能 */}
                    {/* direction;  //消息方向 1代理发给客户 2客户发给代理 */}
                    {isLikeEnabled && content.direction === "1" && (
                        <RadioGroup value={content.tag} options={options} onChange={handleChangeisLike} />
                    )}
                    {/* 翻译功能使能 */}

                    {isTranslateEnabled && (
                        <RadioGroup value={target_language} options={supportedLanguages} onChange={handleChangeLanguage} />
                    )}

                    {/* messageBuilder; //消息构建者 1 客户  2 客服代表 3 AI建议候选 4 人工修正AI 5 AI原文经过人工确认发送 6 模版消息（已经发送） 7模板消息建议候选 */}
                    {_id === lastMessage._id && (content.messageBuilder === "3" ||content.messageBuilder === "7")&& (
                        <div>
                            <Button type="primary" onClick={handleUseSuggestion} disabled={suggestionMsgId !== null}>使用</Button>
                            <Button onClick={handleRegenerateSuggestion}
                                disabled={content.messageBuilder === "7"}>重新生成</Button>
                        </div>
                    )
                    }
                </div>
            </div>
        );
    }
    function handleOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }


    function handleSend(type, val) {
        const MAX_MESSAGE_LENGTH = 200;
        const cleanVal = DOMPurify.sanitize(val);
        if (type === "text") {
            if (!cleanVal.trim()) {
                return;
            }

            if (cleanVal.length > MAX_MESSAGE_LENGTH) {
                toast.fail("消息过长，请缩短后再发送。");
                return;
            }

            const newMessageId = uuidv4();
            /* messageBuilder; //消息构建者 1 客户  2 客服代表 3 AI建议候选 4 人工修正AI 5 AI原文经过人工确认发送 6 模版消息（已经发送） 7模板消息建议候选 */
            let msgBuilder = "2"; //默认为客服消息
            let LastMessage = messages[messages.length - 1];
            let originalContent = {};


            // 针对模版消息特殊处理
            if (LastMessage.content.messageBuilder === "7" && cleanVal !== LastMessage.content.text) {
                    alert("请先使用模版消息，再发送人工修正内容。");            
                    // 清空标识位
                    setSuggestionMsgId(null);
                    setCurrentSuggestion(null);
                    return; 
            } 


            if (suggestionMsgId === null) {
                // 处理当没有使用AI建议时，直接发送的情况
                if (LastMessage.content.messageBuilder === "3") {
                    deleteMsg(LastMessage._id);
                }
            } else {
                if (currentSuggestion && cleanVal === currentSuggestion.trim()) {
                    msgBuilder = "5";
                    const messageIndex = messages.findIndex((msg) => msg._id === suggestionMsgId);
                    console.log("messageIndex:", messageIndex);
                    if (messageIndex !== -1) {
                        originalContent = messages[messageIndex].content;
                    }
                } else if (LastMessage.content.messageBuilder === "7") {
                    msgBuilder = "7"; 
                        alert("请先使用模版消息，再发送人工修正内容。");            
                        // 清空标识位
                        setSuggestionMsgId(null);
                        setCurrentSuggestion(null);
            
                        return; 
                } else {
                    msgBuilder = "4";
                }
                deleteMsg(suggestionMsgId);
            }
            // 清空标识位
            setSuggestionMsgId(null);
            setCurrentSuggestion(null);

            // appendMsg({
            //     _id: newMessageId,
            //     type: "text",
            //     content: {
            //         ...originalContent,
            //         text: cleanVal,
            //         direction: "1",
            //         messageBuilder: msgBuilder
            //     },
            //     position: "right"
            // });
            socket.emit('send_message', {
                ...params,
                content: cleanVal,
                send_time: Date.now(),
                direction: "1",
                message_id: newMessageId,
                frontend_message_id: newMessageId,
                messageBuilder: msgBuilder
            });

        }
    }
    function mockReciveMsg() {
        socket.emit('mock_test_msg', params);
    }

    function handleQuickReplyClick(item) {
        console.log("handleQuickReplyClick", item)
        switch (item.name) {
            case "mock_test_msg":
                mockReciveMsg();
                break;
            case `🌐 ${translateText}`:
                handleOpen();
                break;

            default:
                break;
        }

    }
    const goBack = () => {
        window.history.back();
    };
    const [translatedInput, setTranslatedInput] = useState('');
    const [target_language, setTargetLanguageValue] = useState('');
    const languages = supportedLanguages;

    function handleChangeLanguage(val) {
        setTargetLanguageValue(val);
        translateTo("MsgID_input_text", value3, val);
    }

    return (
        <div className="ChatApp">
            <Chat
                navbar={{
                    title: params.cust_name,
                    leftContent: {
                        label: "<",
                        size: "md",
                        onClick: goBack,
                    },
                    rightContent: [],
                }}
                messages={messages}
                renderMessageContent={(msg) => renderMessageContent(msg)}
                onSend={handleSend}
                quickRepliesVisible={isTranslateEnabled}
                quickReplies={defaultQuickReplies}
                onQuickReplyClick={handleQuickReplyClick}
                composerRef={chatInstanceRef}
            />
            <Popup
                active={open}
                title={translateText}
                onClose={handleClose}

            >
                <div style={{ padding: '1px var(--gutter)' }}>
                    <div style={{
                        display: "flex",
                        padding: '0px 5px',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <div>
                            <RadioGroup
                                value={target_language}
                                options={supportedLanguages}
                                onChange={handleChangeLanguage}
                                disabled={value3 === ""}
                            />
                        </div>
                        <Button
                            style={{ margin: '0px 5px 5px 0px' }}
                            onClick={handleUseTranslatedText}
                            disabled={translatedInput === ""}
                            color="primary"
                        >使用</Button>
                    </div>
                    {translatedInput === "" ? null : (<Divider />)}
                    <div >
                        <div style={{ maxHeight: '7em', overflowY: 'auto' }}>
                            <Text style={{ padding: '0px 6px var(--gutter)' }}>{translatedInput}</Text>
                        </div>
                        <div>
                            <Input
                                autoSize
                                value={value3}
                                onChange={val => setValue3(val)}
                                maxLength={200}
                                placeholder="请输入..."
                            />
                        </div>
                    </div>
                </div>
            </Popup>
        </div>


    );
}
